import { createStyles, makeStyles } from '@mui/styles';

type StylesProps<T> = {
  value: T | string | undefined,
  disabled: boolean
}

export function useStyles<T>(props: StylesProps<T>) {
  const classes = makeStyles((theme: any) => {
    const hairline = `1.2px solid ${theme.palette.border.line}`;
    const fieldStyles = {
      border: hairline,
      borderRadius: '5px',
      backgroundColor: theme.palette.background.paper,
      fontSize: '0.875rem',
      color: theme.palette.text.primary,
      cursor: props.disabled ? "not-allowed" : "pointer"
    };
    const iconStyles = {
      top: 0,
      borderLeft: hairline,
      height: '100%',
      color: theme.palette.action.active,
    };

    const styles = createStyles({
      select: () => {
        const hasValueSelected = props.value !== undefined && (props.value as string) !== '';
        if (hasValueSelected) {
          return ({
            '& .MuiInputBase-input': {
              ...fieldStyles,
              padding: theme.spacing(1),
              paddingRight: theme.spacing(4),
            },
            '& .MuiSelect-icon': iconStyles,
          });
        }

        return ({
          '& .MuiInputBase-input': {
            ...fieldStyles,
            padding: theme.spacing(1),
            paddingRight: theme.spacing(4),
          },
          '& .MuiSelect-icon': iconStyles,
        });
      },
      defaultItemContainer: {
        display: "flex", justifyContent: "space-between", alignItems: "center", gap: "0.5rem"
      },
      // MUI v4 MenuItem defaults to nowrap + overflow hidden, which clips long labels on phones.
      menuItem: {
        whiteSpace: 'normal',
        wordBreak: 'break-word'
      },
      // Applied via MenuProps.classes.paper, not inline PaperProps.style: Select keeps supplying the anchor-width min-width.
      menuPaper: {
        maxWidth: `calc(100vw - ${theme.spacing(4)})`
      }
    });

    return styles;
  });
  return classes();
}
